import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05f281f8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=05f281f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f281f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/var/jenkins_home/workspace/prod-web-xfans/components/banner.vue').default,Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default,Course: require('/var/jenkins_home/workspace/prod-web-xfans/components/course.vue').default})
